import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {ConfigService, SentryService} from '@q9elements/ui-kit/common';
import {DragulaService} from 'ng2-dragula';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {isComponent} from '../../diagram-render/helpers/shapes-detectors.util';
import {DRAGULA_BAG_PREFIXES} from 'src/app/shared/models/dragula.interface';
import {MxCell} from 'src/app/editor-interface/shared/models/mx-cell.interface';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private injector: Injector,
    private sentryService: SentryService
  ) {}

  public handleError(err: any): void {
    if (err.code === err.NOT_FOUND_ERR && /removeChild/.test(err.message)) {
      this.fixResourceError();
      console.warn('Handled: ', err);
    } else {
      console.error(err);
    }

    if (ConfigService.environment.production) {
      this.sentryService.captureException(err);
    }
  }

  private fixResourceError(): void {
    const dragulaSvc = this.injector.get(DragulaService);
    const graphHelper = this.injector.get(GraphHelperService);
    const drakeRef = dragulaSvc.find(DRAGULA_BAG_PREFIXES.ACTIVITY);

    (drakeRef?.drake as any)?.cancel?.(true);
    graphHelper.allActivities().forEach((cell: MxCell) => {
      if (isComponent(cell)) {
        cell.comp.instance.setupFromJson();
      }
    });
  }
}
